import { Injectable } from '@angular/core';
import { SETTINGS } from '../config/common.settings';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Injectable({
  providedIn: 'root',
})
export class LearningResourceService {
  constructor(
    private http: HttpClient,
    private router: Router,
    private message: NzMessageService,
    private ngxLoader: NgxUiLoaderService,
  ) {}

  getBooks(page: number, pageSize: number): Promise<any> {
    this.ngxLoader.start();
    return new Promise((resolve, reject) => {
      return this.http
        .get(
          `${SETTINGS.CMS_API}/api/learningResource?where[type][equals]=Book&page=${page}&limit=${pageSize}`,{withCredentials: true},
        )
        .subscribe(
          (response) => {
            this.ngxLoader.stop();
            resolve(response);
          },
          (error) => {
            this.ngxLoader.stop();
            this.message.create('error', 'Failed to retrieve Books');
            reject(error);
          },
        );
    });
  }

  getBooksBySearch(name: any, page: number, pageSize: number): Promise<any> {
    this.ngxLoader.start();
    return new Promise((resolve, reject) => {
      return this.http
        .get(
          `${SETTINGS.CMS_API}/api/learningResource?where[name][contains]=${name}&page=${page}&limit=${pageSize}&[type][equals]=Book`,{withCredentials: true},
        )
        .subscribe(
          (response) => {
            this.ngxLoader.stop();
            resolve(response);
          },
          (error) => {
            this.ngxLoader.stop();
            this.message.create('error', 'Failed to retrieve Books');
            reject(error);
          },
        );
    });
  }

  getArticles(page: number, pageSize: number): Promise<any> {
    this.ngxLoader.start();
    return new Promise((resolve, reject) => {
      return this.http
        .get(
          `${SETTINGS.CMS_API}/api/learningResource?where[type][equals]=Article&page=${page}&limit=${pageSize}`,{withCredentials: true},
        )
        .subscribe(
          (response) => {
            this.ngxLoader.stop();
            resolve(response);
          },
          (error) => {
            this.ngxLoader.stop();
            this.message.create('error', 'Failed to retrieve Books');
            reject(error);
          },
        );
    });
  }

  getArticlesBySearch(name: any, page: number, pageSize: number): Promise<any> {
    this.ngxLoader.start();
    return new Promise((resolve, reject) => {
      return this.http
        .get(
          `${SETTINGS.CMS_API}/api/learningResource?where[name][contains]=${name}&page=${page}&limit=${pageSize}&[type][equals]=Article`,{withCredentials: true},
        )
        .subscribe(
          (response) => {
            this.ngxLoader.stop();
            resolve(response);
          },
          (error) => {
            this.ngxLoader.stop();
            this.message.create('error', 'Failed to retrieve Books');
            reject(error);
          },
        );
    });
  }

  getVideos(page: number, pageSize: number): Promise<any> {
    this.ngxLoader.start();
    return new Promise((resolve, reject) => {
      return this.http
        .get(
          `${SETTINGS.CMS_API}/api/learningResource?where[type][equals]=Video&where[displayOnWebsiteOnly][not_equals]=true&page=${page}&limit=${pageSize}`,{withCredentials: true},
        )
        .subscribe(
          (response) => {
            this.ngxLoader.stop();
            resolve(response);
          },
          (error) => {
            this.ngxLoader.stop();
            this.message.create('error', 'Failed to retrieve Books');
            reject(error);
          },
        );
    });
  }

  getVideosBySearch(name: any, page: number, pageSize: number): Promise<any> {
    this.ngxLoader.start();
    return new Promise((resolve, reject) => {
      return this.http
        .get(
          `${SETTINGS.CMS_API}/api/learningResource?where[name][contains]=${name}&where[type][equals]=Video&where[displayOnWebsiteOnly][not_equals]=true&page=${page}&limit=${pageSize}`,{withCredentials: true},
        )
        .subscribe(
          (response) => {
            this.ngxLoader.stop();
            resolve(response);
          },
          (error) => {
            this.ngxLoader.stop();
            this.message.create('error', 'Failed to retrieve Books');
            reject(error);
          },
        );
    });
  }

  getSingleArticle(id: any): Promise<any> {
    this.ngxLoader.start();
    return new Promise((resolve, reject) => {
      return this.http
        .get(`${SETTINGS.CMS_API}/api/learningResource/${id}`,{withCredentials: true})
        .subscribe(
          (response) => {
            this.ngxLoader.stop();
            resolve(response);
          },
          (error) => {
            this.ngxLoader.stop();
            this.message.create('error', 'Failed to retrieve Article');
            reject(error);
          },
        );
    });
  }
}
